(function (document) {
  "use strict";

  function closestAction(target) {
    while (target && target !== document) {
      if (target.getAttribute && (
        target.getAttribute("data-moko-operations-action") ||
        target.getAttribute("data-moko-admin-action")
      )) {
        return target;
      }
      target = target.parentNode;
    }
    return null;
  }

  // Ajaxで挿入された操作UIにも対応する。認可は各サーバー側actionで再確認する。
  document.addEventListener("click", function (event) {
    var action = closestAction(event.target);
    if (!action || typeof CustomEvent !== "function") {
      return;
    }
    document.dispatchEvent(new CustomEvent("moko-operations-action", {
      detail: {
        action: action.getAttribute("data-moko-operations-action") ||
          action.getAttribute("data-moko-admin-action"),
        element: action
      }
    }));
  });
})(document);
